export const arrayOf = (n) => [...new Array(n).fill()];
